import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled/macro';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Button from 'components/Button';
import Card from 'components/Card';
import CardContent from 'components/CardContent';
import File from 'components/File';
import SectionTitle from 'components/SectionTitle';
import { sectionActions } from 'redux/documentSection';
import { seeMoreProps } from 'services/urlService';
import CloudIntegrationIndicator from './Partials/CloudIntegrationIndicator';

const emptyArray = [];

const Files = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const SeeAll = styled(Button)`
  color: #888;
  font-size: 0.9rem;
  font-weight: 600;

  margin-top: 0.75rem;
  margin-left: -0.5rem;
`;

const DocumentWidget = ({ title, files = emptyArray, total = 0, folderId, folderVariantId, sectionId, seeMoreUrl, ...rest }) => {

  const { t } = useTranslation(['common']);

  const dispatch = useDispatch();

  if (files.length === 0) {
    return null;
  }

  const onFileClick = () => {
    if (sectionId) {
      dispatch(sectionActions.postSectionClickForMember({ sectionId }));
    }
  };

  const seeMore = seeMoreProps(seeMoreUrl);

  return (
    <div {...rest}>
      <Card>
        <CardContent>
          <SectionTitle seeMore={seeMore}>{title ?? t('documentWidget.title')}</SectionTitle>
          <Files>
            {files.map(({ id, name, size, url, integration }) => (
              <File
                key={id}
                url={url}
                name={name}
                size={size}
                fullWidth
                onClick={onFileClick}
                endIcon={integration ? <CloudIntegrationIndicator edge="end" integration={integration} /> : null}
              />
            ))}
          </Files>
          {seeMore && total > files.length && (
            <SeeAll variant="text" size="small" endIcon={<NavigateNextIcon fontSize="inherit" />} {...seeMore}>
              {t('documentWidget.allDocuments', { count: total })}
            </SeeAll>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

DocumentWidget.propTypes = {
  title: PropTypes.node,
  files: PropTypes.array,
  total: PropTypes.number,
  folderId: PropTypes.number,
  folderVariantId: PropTypes.number,
  sectionId: PropTypes.number,
  seeMoreUrl: PropTypes.string,
};

export default DocumentWidget;
